import { render, staticRenderFns } from "./HotelFeatures.vue?vue&type=template&id=530ec51b&scoped=true&"
import script from "./HotelFeatures.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelFeatures.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelFeatures.vue?vue&type=style&index=0&id=530ec51b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ec51b",
  null
  
)

export default component.exports